import moment from "moment";
import type { MillId } from "@/setup/mill-config/mill-config";

export interface SectionExport {
	AssetId: MillId;
	SectionId: number;
	SectionName: string;
	SectionFamilyName: string | null;
	TonsPerHour: number | null;
	TargetTPH: number | null;
	TargetTPHPercentage: number | null;
	LBsPerFoot: number | null;
	BilletSize: number | null;
	MillYield: number | null;
	FinishedYield: number | null;
	Description: string | null;
	StandDrawingCount: number | null;
	StandCount: number | null;
	HasProductionEvents: boolean;
}

export interface SectionExportStand {
	StandId: number;
	StandName: string;
}

export interface SectionExportStandSetup {
	SectionId: number;
	StandId: number;
	SetpointGap: number | null;
	StandTypeCode: "U" | "E";
	WidthMeasurement: number | null;
	EdgerOrientationCode: "H" | "D" | null;
	Area: number | null;
}

export interface SectionExportSelection {
	SectionId: number;
	AssetId: MillId;
}

export interface SectionExportSpec extends SectionExportSelection {
	Rev: number;
	SubRev: number;
	EffectiveDate: string;
	PrintNo: string | null;
	Area: number | null;
	TargetLbsPerFoot: number | null;
	MinLbsPerFoot: number | null;
	MaxLbsPerFoot: number | null;
	LegDeltaMax: number | null;
	Comments: string | null;
}

export interface SectionExportItem {
	AssetId: MillId;
	ProfileItemId: number;
	CategoryName: string;
	ValueTypeCode: "V" | "A";
	Code: string;
	Name: string;
}

export interface SectionExportSpecItem extends SectionExportSelection {
	ProfileItemId: number;
	Ltl: number | null;
	Nominal: number | null;
	Utl: number | null;
}

export interface SectionsExportData {
	sections: SectionExport[];
	stands: SectionExportStand[];
	standSetups: SectionExportStandSetup[];
	specs: SectionExportSpec[];
	items: SectionExportItem[];
	specItems: SectionExportSpecItem[];
}

export const formatSpecRevision = (
	rev: number | null,
	subRev: number | null,
) =>
	rev == null
		? null
		: subRev != null && subRev > 0
			? `${rev}.${subRev}`
			: `${rev}`;

export const toExcelDateTime = (utcDate: string | null) =>
	utcDate == null
		? null
		: moment.utc(utcDate).local().format("YYYY-MM-DDTHH:mm:ss");
